// extracted by mini-css-extract-plugin
export default {"timer":"utils_timer__ePHlt"};